import React from 'react';
import Menu, { MenuProps } from '@material-ui/core/Menu';
import {
	useDisableFocusTrapWithChatProps
} from '@components/ChatAwareComponents/utilities/hooks/useDisableFocusTrapWithChatProps/useDisableFocusTrapWithChatProps';

export const ChatAwareMenu: React.FC<MenuProps> = ({ children, ...menuProps }) => {
	const disableFocusTrapWithChatProps = useDisableFocusTrapWithChatProps();

	return (
		<Menu
			{...disableFocusTrapWithChatProps}
			{...menuProps}
		>
			{children}
		</Menu>
	);
};
